/* globals $:false */

import TasksGroupEditVue from './tasks-group-edit.vue';
import TasksVue from './tasks.vue';
import Vue from 'vue';

var Tasks = function(core, _instance, confs){
    var vm;
    var data = {
        tasks: [],
        permissions: {},
        readonly: confs.readonly,
        usermBaseUrl: core.getUserMUrl(),
        i18n: {
            locale: core.getLocale(),
            searchUser: core.translateString('recordm.instances', 'tasks.searchUser')
        }
    };

    var _$html = $('<div id="tasks">TASKS</div>');

    var _render = function(){
        return _$html;
    };

    var _afterRender = function(){
        vm = new Vue({
            components: { 'tasks': TasksVue },
            el: _$html[0],
            template: `<tasks
                v-model="tasks"
                :permissions="permissions"
                :readonly="readonly"
                :usermBaseUrl="usermBaseUrl"
                :i18n="i18n"></tasks>`,
            data: data
        });

        vm.$watch('tasks', confs.valueChanged, { deep: true });
    };

    var _destroy = function(){
        vm.$destroy();
    };

    return {
        afterRender: _afterRender,
        render: _render,
        destroy: _destroy,

        clearError: _dummy,
        showError: _dummy,

        setValue: function(value){
            if(typeof value === 'undefined' || value.trim() === ''){
                data.tasks = [];
            } else {
                try{
                    const valueJson = JSON.parse(value);
                    if(Array.isArray(valueJson)) data.tasks = valueJson;
                }catch(e){
                    window.console.error('Invalid value for tasks field: "' + value + '"', e)
                }
            }
        },
        setTasks: function(tasks){
            let fakeIds = 0;
            tasks.forEach((t) => {
                t.id = ++fakeIds;
                // convert from ISO-8601 to Date
                if(t.date) t.date = new Date(t.date);
            });
            data.tasks = tasks
        },
        setPermissions: function(permissions){
            data.permissions = permissions
        },

        getValue: function(){
            if(data.readonly && data.tasks.length === 0) return null;

            return JSON.stringify(data.tasks.map((t) => ({
                name: t.name,
                correlationId: t.correlationId,
                state: t.state,
                assignee: t.assignee,
                // convert from Date object to date part of ISO-8601
                date: t.date ? t.date.toISOString().split('T')[0] : undefined
            })));
        },
        getTasks: function(){
            return data.tasks;
        }
    }
};

/* eslint-disable-next-line func-style */
export function TasksGroupEdit(core, _instance, confs){
    var vm;
    var data = {
        operation: {name: '', tasks: [{}]},
        readonly: confs.readonly,
        usermBaseUrl:core.getUserMUrl(),
        i18n: {
            locale: core.getLocale(),
            addTasks: core.translateString('recordm.instances', 'tasks.add'),
            completeTasks: core.translateString('recordm.instances', 'tasks.complete'),
            assignTasks: core.translateString('recordm.instances', 'tasks.assign'),
            searchUser: core.translateString('recordm.instances', 'tasks.searchUser')
        }
    };


    var _$html = $('<div id="tasks">TASKS</div>');

    var _render = function(){
        return _$html;
    };

    var _afterRender = function(){
        vm = new Vue({
            components: { 'tasks': TasksGroupEditVue },
            el: _$html[0],
            template: `<tasks v-model="operation" :readonly="readonly" :usermBaseUrl="usermBaseUrl" :i18n="i18n"></tasks>`,
            data: data
        });
    };

    var _destroy = function(){
        vm.$destroy();
    };

    return {
        afterRender: _afterRender,
        render: _render,
        destroy: _destroy,

        clearError: _dummy,
        showError: _dummy,

        setValue: _dummy,
        getValue: function(){
            if(data.readonly && data.operation.tasks.length === 0) return null;

            return `${data.operation.name}:${JSON.stringify(data.operation.tasks)}`
        }
    }
}

/* eslint-disable-next-line func-style */
export function TasksSearch(core, fieldConf){
    const valueId = fieldConf.id;
    const $html = $(
        `<input type=text class='field-value cob-field-value js-field-value value-field' id="f${valueId}">`
    );

    return {
        render: function(){
            return $html;
        },

        getValue: function(){
            return $html[0].value
        },

        setValue: function(newValue){
            $html[0].value = newValue
        },

        destroy: function(){ /* nothing to do */ }
    }
}

var _dummy = function() {
    //do nothing
};

export default Tasks;

// vim: sw=4 ts=4 et
